import React from 'react';
import { Panel, Typography } from '@icecreamsocial/components';
import { Tooltip } from '../Tooltip';

export const Block = ({ label, tooltipLabel, stat = 'No Data' }) => (
	<Panel textAlign='center' backgroundColor='ambient'>
		<Panel.Body
			display='flex'
			flexDirection='column'
			alignItems='center'
			style={{ gap: '12px' }}
		>
			<Tooltip arialLabel='info' title={tooltipLabel} placement='top' arrow>
				<Typography.Span
					typoSize='sm'
					borderBottom='1px dashed'
					borderColor='ambientDark'
					elWidth='fit-content'
					style={{ cursor: 'help' }}
				>
					{label}
				</Typography.Span>
			</Tooltip>
			<Typography.Span typoWeight='500' typoSize='lg'>
				{stat}
			</Typography.Span>
		</Panel.Body>
	</Panel>
);
